import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Strategies/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class StrategiesQueries extends VueCqrs
{
	runStrategyByWorkspaceIdQueryV1(workspaceId: number)
	{
		const query = q.buildStrategyByWorkspaceIdQueryV1(workspaceId);
		this.$query(query);
	}

	runStrategySettingsQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildStrategySettingsQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runStrategyFixPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildStrategyFixPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runProjectPlanTemplatesPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildProjectPlanTemplatesPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}


	runAllProjectsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildAllProjectsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runProposedProjectsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildProposedProjectsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runScheduledProjectsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildScheduledProjectsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runStartedProjectsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildStartedProjectsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runFinishedProjectsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildFinishedProjectsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}
}